import { useDispatch, useSelector } from 'react-redux';

import '../../styles/FilterForArchive.css';
import Selector from '../CustomElements/Selector';
import Input from '../CustomElements/Input';
import DateRangePicker from '../CustomElements/DateRangePicker';
import Accordeon from '../CustomElements/Accordeon';
import useOptionsLoader from '../../customHook/useOptionsLoader';

import { handleUniversalChange } from '../../utils/formUtils';
import {
  initDepartmentOptionsFromServer,
  initOptionsDirectoratesFromServer,
  initOptionsSectionFromServer,
} from '../../redux/actions/options.action';
import { clearArchive } from '../../redux/actions/archive.action';

function FilterForArchive({ formData, setFormData, showBtnReset, resetFilters, t }) {
   const dispatch = useDispatch();
  // получаем опции из стора
  const optionsForSelect = useSelector((state) => state.options);

  const message = formData?.start && formData?.finish ? null : t?.datePlaceholder || 'Выберите период';

  const messageForSelectDirectorates = t?.roadPlaceholder || 'Выберите дорогу';
  const directoratesControl = useOptionsLoader(
    formData,
    setFormData,
    ['directorateId', 'departmentId'],
    'roadId',
    initOptionsDirectoratesFromServer,
    messageForSelectDirectorates
  );

  //хук для запроса опций для подразделений и контроля селекта
  const messageForSelectDepartments = t?.messageForSelectDepartments || 'Выберите дирекцию';
  const departmentsControl = useOptionsLoader(
    formData,
    setFormData,
    ['departmentId'],
    'directorateId',
    initDepartmentOptionsFromServer,
    messageForSelectDepartments
  );

  //хук для запроса опций для станций и контроля селекта
  const messageForSelectStation = t?.messageForSelectDirectorates || 'Выберите дорогу';
  const stationControl = useOptionsLoader(
    formData,
    setFormData,
    ['stationId'],
    'roadId',
    initOptionsSectionFromServer,
    messageForSelectStation
  );

  return (
    <Accordeon
      header={t?.archive || 'АРХИВ'}
      hideAbove={1650}
      qParamName={'docs_acc'}
      formData={formData}
      resetFilters={resetFilters}
    >
      <button
        type="button"
        className={`accordeon__reset-filters ${showBtnReset && 'accordeon__reset-filters_visible'}`}
        onClick={() => {
          resetFilters(false);
          dispatch(clearArchive())
        }}
      >
        <span className="accordeon__reset-filters_text">{t?.resetFiltersButton || 'Сбросить все фильтры'}</span>
        <img className="accordeon__reset-filters_icon" src="/image/close.svg" alt=""></img>
      </button>

      <form className="accordeon__form" id="" method="POST" action="#" autoComplete="off">
        <div className="accordeon__select-container" id="">
          <Input
            onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 6)}
            value={formData?.brigadeId}
            name="brigadeId"
            label={t?.idLabel || 'ID ИУР'}
            placeholder={t?.iurIdPlaceholder || 'Введите ID ИУР'}
            maxLength={6}
          />
          <Input
            onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 6)}
            value={formData?.deviceId}
            label={t?.iurIdLabel || 'Устройство'}
            placeholder={t?.devicePlaceholder || 'Введите ID устройства'}
            name="deviceId"
            maxLength={6}
          />
          <Selector
            options={optionsForSelect.roads}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'roadId', selectedOption, 'select');
            }}
            isMulti={false}
            label={t?.roadLabel || 'Дорога'}
            placeholder={t?.roadPlaceholder || 'Выберите дорогу'}
            value={formData.roadId ? optionsForSelect?.roads?.find((option) => option.value === formData.roadId) : null}
            name="roadId"
          />
          <Selector
            column="right"
            options={optionsForSelect?.directorates}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'directorateId', selectedOption, 'select');
            }}
            label={t?.directorateLabel || 'Дирекция'}
            placeholder={t?.directoratePlaceholder || 'Выберите дирекцию'}
            value={
              formData.directorateId
                ? optionsForSelect?.directorates?.find((option) => option.value === formData.directorateId)
                : null
            }
            isMulti={false}
            name="directorateId"
            isDisabled={directoratesControl?.isSelectorDisabled}
            message={directoratesControl?.message}
            customClick={directoratesControl?.onSelectorChange}
          />
          <Selector
            options={optionsForSelect.departments}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'departmentId', selectedOption, 'select');
            }}
            isMulti={false}
            label={t?.departmentLabel || 'Подразделение'}
            placeholder={t?.departmentPlaceholder || 'Выберите подразделение'}
            value={
              formData.departmentId
                ? optionsForSelect?.departments?.find((option) => option.value === formData.departmentId)
                : null
            }
            name="departmentId"
            isDisabled={departmentsControl?.isSelectorDisabled}
            message={departmentsControl?.message}
            customClick={departmentsControl?.onSelectorChange}
          />
          <Selector
            options={optionsForSelect?.stations}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'stationId', selectedOption, 'select');
            }}
            value={
              formData?.stationId
                ? optionsForSelect.stations?.find((option) => option.value === formData.stationId)
                : null
            }
            isMulti={false}
            name="stationId"
            label={t?.stationLabel || 'Станция/перегон'}
            placeholder={t?.stationPlaceholder || 'Выберите станцию/перегон'}
            isDisabled={stationControl?.isSelectorDisabled}
            message={stationControl?.message}
            customClick={stationControl?.onSelectorChange}
          />
          <DateRangePicker
            formData={formData}
            setFormData={setFormData}
            startDateField="start" // имя поля для даты начала, с дефолтным значением
            endDateField="finish" // имя поля для даты окончания, с дефолтным значением
            label={t?.periodLabel || 'Период *'}
            placeholder={t?.datePlaceholder || 'Выберите период'}
            name="datePeriod"
            message={message}
            maxDate={
              formData?.start
                ? new Date(
                    Math.min(
                      new Date().getTime(),
                      new Date(new Date(formData.start).setMonth(new Date(formData.start).getMonth() + 1)).getTime()
                    )
                  )
                : new Date()
            }
          />
        </div>
      </form>
    </Accordeon>
  );
}

export default FilterForArchive;
